module.exports = __webpack_public_path__ + "static/media/elanwave.7eef61b6.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/elanwave.webp
// module id = 610
// module chunks = 0